import { render, staticRenderFns } from "./forecastitem.vue?vue&type=template&id=c2b56670&"
import script from "./forecastitem.vue?vue&type=script&lang=js&"
export * from "./forecastitem.vue?vue&type=script&lang=js&"
import style0 from "./forecastitem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports